var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon12({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58.11px",
    height: "70.53px",
    viewBox: "0 0 58.11 70.53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-1281.830000, -2419.880000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2",
    transform: "translate(-0.060000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path_117",
    fill: "#BEB0FF",
    points: "1306.74 2459.35 1281.89 2459.35 1281.89 2450.95 1306.74 2450.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_118",
    fill: "#000000",
    points: "1340 2428.29 1281.89 2428.29 1281.89 2419.88 1340 2419.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_119",
    fill: "#000000",
    points: "1327.57 2443.82 1281.89 2443.82 1281.89 2435.41 1327.57 2435.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_120",
    fill: "#000000",
    points: "1327.57 2474.88 1281.89 2474.88 1281.89 2466.48 1327.57 2466.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_121",
    fill: "#000000",
    points: "1302.72 2490.41 1281.89 2490.41 1281.89 2482.01 1302.72 2482.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_122",
    fill: "#000000",
    points: "1310.95 2450.95 1340 2450.95 1340 2459.35 1310.95 2459.35"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/Icon12.65562e99532a907bc928be2e7b86c97c.svg";
export { ForwardRef as ReactComponent };